module.exports = __webpack_public_path__ + "img/pay-error.e93c02e7.png";